import { ChooseMember } from 'app/src/components/ChooseMember';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import Util from 'app/scripts/lib/util/index.coffee';

interface Member {
  id: string;
  fullName: string;
  username: string;
}

interface OptionsFunctions {
  getInput: () => HTMLInputElement | HTMLTextAreaElement;
  getCardMembers: (this: unknown) => Member[];
  getBoardMembers: (this: unknown) => Member[];
}

interface Options extends OptionsFunctions {
  title: string;
}

function bind<T extends () => unknown>(fn: T, context: unknown): T {
  return fn.bind(context);
}

export function toggleAssignPopover(options: Options) {
  const { title } = options;

  return function toggle(e: MouseEvent) {
    Util.stop(e);

    const getInput = bind(options.getInput, this);
    const getCardMembers = bind(options.getCardMembers, this);
    const getBoardMembers = bind(options.getBoardMembers, this);

    const input = getInput();

    const initialValue = input.value;
    const usernameMatch = initialValue.match(/^@[a-z0-9]{3,}/);
    // Clip @ off the front
    const existingUsername = usernameMatch && usernameMatch[0].substr(1);
    const existingMember =
      existingUsername &&
      getBoardMembers().find((member) => member.username === existingUsername);
    const idMemberInitial = existingMember ? existingMember.id : undefined;

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <ChooseMember
          key="choose-member"
          {...{
            idMemberInitial,
            getCardMembers,
            getBoardMembers,
          }}
          onSelect={(member) => {
            PopOver.hide();

            if (
              (member && member.id === idMemberInitial) ||
              (!member && !idMemberInitial)
            ) {
              return;
            }

            const mention = member
              ? /^\s/.test(initialValue)
                ? `@${member.username}`
                : `@${member.username} `
              : '';

            const newValue = idMemberInitial
              ? initialValue.replace(/^@[a-z0-9_]{3,}\s?|^/, mention)
              : mention + initialValue;

            const delta = newValue.length - initialValue.length;
            const selectionStart = input.selectionStart;
            const selectionEnd = input.selectionEnd;

            input.value = newValue;

            if (selectionStart !== null && selectionEnd !== null) {
              const newSelectionStart =
                selectionStart === 0 &&
                selectionEnd === initialValue.length &&
                selectionEnd > selectionStart
                  ? // If they've got everything selected, keep everything selected
                    0
                  : Math.max(0, selectionStart + delta);

              const newSelectionEnd = selectionEnd + delta;
              input.setSelectionRange(newSelectionStart, newSelectionEnd);
            }

            input.focus();
          }}
        />
      ),
    });
  };
}
